export default {
	name: "BOD",
	audio: {},
	connection: "ftp",
	disableArticles: ["total", "part", "ebook"],
	allowMissingISBN: true,
};
